import { render, staticRenderFns } from "./Chat-Bot.vue?vue&type=template&id=0a6812c7&scoped=true"
import script from "./Chat-Bot.vue?vue&type=script&lang=js"
export * from "./Chat-Bot.vue?vue&type=script&lang=js"
import style0 from "./Chat-Bot.vue?vue&type=style&index=0&id=0a6812c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6812c7",
  null
  
)

export default component.exports